// extracted by mini-css-extract-plugin
module.exports = {"formText":"customSearch_formText__2SE2U","CustomSearchBar":"customSearch_CustomSearchBar__19vXg","searchIcon":"customSearch_searchIcon__3EpfT"};